import { derived, writable, get } from 'svelte/store';
import { location } from 'svelte-spa-router';

export type SidePanelStateType = {
	type?: string;
	id?: string;
	open?: boolean;
	showSettingsModal?: boolean;
};

export const getDrawerState = () => {
	if (get(location).split('/')[2] === 'room')
		return { type: 'room', id: get(location).split('/')[3], open: false };
	return { type: 'dash', open: false };
};

export const sidePanelState = writable<SidePanelStateType>(getDrawerState());

export const sidepanelDesktopOnTop = writable<boolean>(true);
export const sidepanelChartMode = writable<boolean>(false);
